/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CheckAuthOptions, CheckAuthResponses } from '../../models/CheckAuth'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Check if the user is authenticated.
 * If the user is using an existing token, indicate that the user is authenticated.
 * If the user is using a proxy IP address, create a proxy user if necessary and provide tokens for the user.
 * @summary Check Auth
 * {@link /auth/check-auth}
 */
export function checkAuth<ThrowOnError extends boolean = true>(options: Options<CheckAuthOptions, ThrowOnError> = {}): Promise<UnwrappedResult<CheckAuthResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/auth/check-auth', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CheckAuthResponses, ThrowOnError>>
}
